import colors from './variables.module.scss';

const styles = {
  ...colors,
  MENU_HEADER_HEIGHT: 71,
};

export default styles;
